module.exports = __webpack_public_path__ + "static/img/Bachelor_010523.f1aeaa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010523.jpg
// module id = 178
// module chunks = 0